import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { PrincipalService } from './principal.service';

@Directive({
  selector: '[hasAuthority]'
})
export class HasAuthorityDirective implements OnInit {

  @Input() hasAuthority: string;
  authority: string;

  constructor(private principal: PrincipalService, private el: ElementRef, private renderer: Renderer2) {
  }

  ngOnInit() {
    this.authority = this.hasAuthority.replace(/\s+/g, '');
    if (this.authority.length > 0) {
      this.setVisibilityAsync();
    }
    this.principal.getAuthenticationState().subscribe(identity => this.setVisibilitySync());
  }

  private setVisibilitySync() {
    if (this.principal.hasAnyAuthority([this.authority])) {
      this.setVisible();
    } else {
      this.setHidden();
    }
  }

  private setVisible() {
    this.renderer.removeClass(this.el.nativeElement, 'hidden');
  }

  private setHidden() {
    this.renderer.addClass(this.el.nativeElement, 'hidden');
  }

  private setVisibilityAsync() {
    this.principal.hasAuthority(this.authority).then(result => {
      if (result) {
        this.setVisible();
      } else {
        this.setHidden();
      }
    });
  }
}
